export interface DeltaChipProps {
  /** Cifra ya formateada, sin signo ni flecha ("12%", "$230"). */
  value: string;
  /** Dirección REAL del cambio; dibuja la flecha. */
  direction: "up" | "down" | "flat";
  /** good → positivo · bad → negativo · neutral → ink-muted. Por defecto: neutral si `flat`, si no good. */
  sentiment?: "good" | "bad" | "neutral";
  /** Periodo de comparación ("vs. ago"). */
  period?: string;
  size?: "md" | "sm";
  /** Sobre tarjeta sun: píldora negra con texto amarillo. */
  onCard?: boolean;
}

const ARROW = { up: "↑", down: "↓", flat: "=" } as const;
const SPOKEN = { up: "Sube", down: "Baja", flat: "Sin cambio" } as const;
const TONE = {
  good: "text-[var(--ds-positive)] border-current",
  bad: "text-[var(--ds-negative)] border-current",
  neutral: "text-[var(--ds-ink-muted)] border-current",
} as const;

/** Cambio frente a otro periodo. La flecha y el texto llevan el significado; el color solo refuerza. */
export function DeltaChip({ value, direction, sentiment, period, size = "md", onCard = false }: DeltaChipProps) {
  const tone = sentiment ?? (direction === "flat" ? "neutral" : "good");
  return (
    <span
      className={[
        "inline-flex items-center gap-1 whitespace-nowrap rounded-[var(--ds-radius-pill)] border-[1.5px] border-solid font-medium leading-none",
        size === "md" ? "h-7 px-3 text-[13px]" : "h-6 px-2 text-xs",
        onCard ? "border-[var(--ds-on-card)] bg-[var(--ds-on-card)] text-[var(--ds-card-sun)]" : TONE[tone],
      ].join(" ")}
    >
      <span className="sr-only">{SPOKEN[direction]} </span>
      <span aria-hidden="true">{ARROW[direction]}</span>
      {value}
      {period && <small className="ml-0.5 text-xs font-normal">{period}</small>}
    </span>
  );
}
